import React, { useEffect, useState } from "react";
import Layout from "../../componentes/Comunes/Layout/Layout";
import ServicioComun from "../../servicios/Comun";
import "./Customstyle.css";

function Inicio() {
  const [Contactos, SetContatos] = useState([]);

  useEffect(() => {
    async function CargarContactos() {
      const contactos = await ServicioComun.ObtengaContactosCic();
      SetContatos(contactos);
    }

    CargarContactos();
  }, []);

  return (
    <Layout>
      <div>
        <div className="jumbotron mycustom-jumbotron">
          <h1>Centro de Información Crediticia</h1>
        </div>

        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              {" "}
              Contactos para consultas
            </h6>
          </div>
          <div className="card-body">
            <div className="row">
              {Object.keys(Contactos).length > 0
                ? Contactos.map((item, index) => (
                    <div key={index} className="col-6">
                      <table
                        id={"tbContactos_" + index}
                        className="table table-sm"
                      >
                        <thead className="table-primary">
                          <tr>
                            <th>{item.nombreParametro}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.valor.split(",").map((item2, index2) => (
                            <tr key={index2}>
                              <td>{item2}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Inicio;
